import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class FeedReadPositionAction extends BaseOption {
  static userInterfaceComponent = {
    label: "Mark read with",
    component: inspectorTools.SIMPLE_PICKER,
    descriptionMessage: "Fired once after the feed opens at the separator, so the rows count as read.",
    props: {
      options: [],
    },
  };

  static defaultValue = "";
}
